import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../components/site/Seo";
import { SectionHeader } from "../components/site/Cards";
import { Input } from "../components/ui/input";
import { Search } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  useSeo({ title: "Blog | Agni Shiksha", description: "Preparation strategies, exam updates and tips for SSC, UPSC, Banking and Railway aspirants." });
  useEffect(() => { api.get(`/blog${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setPosts(r.data)).catch(() => {}); }, [q]);
  return (
    <div className="container-px section-y">
      <SectionHeader eyebrow="Blog" title="Strategies & updates" subtitle="Actionable preparation advice from the Agni Shiksha team." />
      <div className="relative max-w-md mb-8">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-content-muted" />
        <Input defaultValue={q} placeholder="Search articles…" onKeyDown={(e) => { if (e.key === "Enter") setParams(e.target.value ? { q: e.target.value } : {}); }} className="pl-9 bg-card border-line rounded-full" data-testid="blog-search" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((b) => (
          <Link key={b.id} to={`/blog/${b.slug}`} className="card-surface p-6 hover:border-ember/60 transition-all" data-testid={`blog-card-${b.slug}`}>
            <span className="text-[11px] uppercase tracking-wider text-ember">{b.category}</span>
            <h3 className="font-heading font-semibold text-base my-2 leading-snug">{b.title}</h3>
            <p className="text-sm text-content-secondary line-clamp-3">{b.excerpt}</p>
          </Link>
        ))}
      </div>
      {posts.length === 0 && <div className="card-surface p-10 text-center text-content-muted">No articles found.</div>}
    </div>
  );
}
